import Marquee from "react-fast-marquee";
import cl1 from "../../assets/img/clients/c1.png";
import cl2 from "../../assets/img/clients/c2.png";
import cl3 from "../../assets/img/clients/c3.png";
import cl4 from "../../assets/img/clients/c4.png";
import cl5 from "../../assets/img/clients/c5.png";
import cl6 from "../../assets/img/clients/c6.png";
import cl7 from "../../assets/img/clients/c7.png";
import cl8 from "../../assets/img/clients/c8.png";
import cl9 from "../../assets/img/clients/c9.png";
import cl10 from "../../assets/img/clients/c10.png";


//Carousel.jsx


const ClientMarque = () => {


    return (
        <>
            <div className="marque_holder">
                <Marquee>
                    <div className="mx-4"><img src={cl1} alt="" style={{ width: '120px' }} /></div>
                    <div className="mx-4"><img src={cl2} alt="" style={{ width: '120px' }} /></div>
                    <div className="mx-4"><img src={cl3} alt="" style={{ width: '120px' }} /></div>
                    <div className="mx-4"><img src={cl4} alt="" style={{ width: '120px' }} /></div>
                    <div className="mx-4"><img src={cl5} alt="" style={{ width: '120px' }} /></div>
                    <div className="mx-4"><img src={cl6} alt="" style={{ width: '120px' }} /></div>
                    <div className="mx-4"><img src={cl7} alt="" style={{ width: '120px' }} /></div>
                    <div className="mx-4"><img src={cl8} alt="" style={{ width: '120px' }} /></div>
                    <div className="mx-4"><img src={cl9} alt="" style={{ width: '120px' }} /></div>
                    <div className="mx-4"><img src={cl10} alt="" style={{ width: '120px' }} /></div>
                </Marquee>
            </div>
        </>
    );
};

export default ClientMarque;